<script setup>
import { time2Date } from '#imports'
import { countDown } from '~/utils/tools'
import airdropAmount from './Amount.vue'
import airdropButton from './Button.vue'

import { computed, onUnmounted, ref } from 'vue'

const props = defineProps({
  itemInfo: {
    type: Object,
    default: () => ({

    }),
  },
})

const countdownTime = ref(props.itemInfo.countdownTime)
const timeleft = computed(() => {
  return countDown(countdownTime.value, { hasDay: true })
})

const shouldShowDropStep = computed(() => !['prod'].includes(import.meta.env.VITE_ENV))

const timer = setInterval(() => {
  if (countdownTime.value > 0) {
    countdownTime.value--
  }
}, 1000)

onUnmounted(() => {
  clearInterval(timer)
})
</script>

<template>
  <div class="flex flex-col justify-between gap-4 p-6 border rounded-xl bg-pageGray border-border max-md:p-4 max-md:bg-transparent">
    <div class="flex justify-between gap-[62px] max-md:flex-col max-md:gap-4">
      <!-- 币种信息 -->
      <div class="flex items-center gap-2 max-md:gap-2  max-w-[80%] max-md:max-w-[90%]">
        <div class="w-[60px] rounded-full max-md:w-[40px]">
          <img :src="itemInfo.symbolIcon" alt="" class="w-full rounded-full">
        </div>
        <div class="flex flex-col justify-center flex-1 min-w-0 ">
          <h2 class="text-xl font-bold text-textPrimary max-md:text-lg">
            {{ itemInfo.symbol }}
          </h2>

          <div class="w-full overflow-hidden md:mt-2 max-md:max-w-[260px]">
            <p class="w-full overflow-hidden whitespace-nowrap text-ellipsis text-textTertiary text-xs">
              {{ itemInfo.symbolDesc }}
            </p>
          </div>
        </div>
      </div>

      <!-- 空投金额 -->
      <div class="flex-col hidden max-md:items-center max-md:flex max-md:justify-center">
        <airdrop-amount :amount="itemInfo.airdropAmount" :usdt-amount="itemInfo.airdropValueUsdt" :symbol="itemInfo.symbol" />
      </div>

      <div class="flex items-center max-md:flex-col">
        <!-- 参与人数 -->
        <div class="hidden gap-1 justify-between items-center h-[28px]  max-md:flex max-md:w-full">
          <span class="text-sm text-textSecondary max-md:text-xs">{{ $t('参与人数') }}</span>
          <span class="text-sm text-textPrimary max-md:text-xs max-md:font-medium">{{ itemInfo.projectStatus > 0 && itemInfo.joinUserCount ? fix(itemInfo.joinUserCount) : 0 }}</span>
        </div>
        <!-- 倒计时 -->
        <div v-if="shouldShowDropStep" class="font-medium max-md:w-full max-md:flex max-md:justify-between max-md:items-center">
          <p class="text-sm text-textSecondary max-md:text-xs">
            {{ itemInfo.projectStatus === 2 ? $t('结束时间') : itemInfo.projectStatus === 1 ? $t('距结束') : $t('距开始') }}
          </p>
          <div v-if="itemInfo.projectStatus !== 2 && timeleft[0] >= 0" class="flex items-center gap-2 text-textPrimary max-md:w-auto max-md:font-medium">
            <template v-for="(item, index) in timeleft" :key="index">
              <span class="inline-flex items-center justify-center w-[22px] h-[28px] max-md:h-6 text-sm rounded bg-fillPagePrimary max-md:bg-pageTertiary max-md:text-xs">{{ item }}</span>
              <span v-if="index < timeleft.length - 1">{{ index === 0 ? $t('天') : ':' }}</span>
            </template>
          </div>
          <div v-else class="flex items-center gap-2 text-right text-textPrimary max-md:w-auto">
            <span class="text-sm font-medium max-md:text-xs">{{ time2Date(new Date(itemInfo.endTime) * 1, 'y-m-d h:i:s') }}</span>
          </div>
        </div>
      </div>

      <!-- 报名按钮 -->
      <airdrop-button
        :activity-id="itemInfo.id"
        :btn-text="itemInfo.projectStatus === 1 && !itemInfo.userJoinStatus ? $t('前往报名') : $t('查看详情')"
        class="hidden max-md:block"
        :class-name="{
          'bg-transparent text-textPrimary border border-textPrimary': itemInfo.projectStatus !== 1,
          'text-textOnBtn hover:bg-btnPrimaryHover': itemInfo.projectStatus === 1,
        }"
      />
    </div>

    <!-- 参与信息 -->
    <div class="flex h-[116px] bg-fillPagePrimary rounded-xl px-6 py-[30px] max-md:hidden">
      <div class="grid w-full grid-cols-3">
        <airdrop-amount :amount="itemInfo.airdropAmount" :usdt-amount="itemInfo.airdropValueUsdt" :symbol="itemInfo.symbol" />
        <div class="flex flex-col items-center justify-center gap-1">
          <div class="w-[100px] flex flex-col ms-10">
            <span class="text-sm font-medium text-textSecondary">{{ $t('参与人数') }}</span>
            <span class="text-2xl font-bold text-textPrimary">{{ itemInfo.projectStatus > 0 && itemInfo.joinUserCount ? fix(itemInfo.joinUserCount) : 0 }}</span>
          </div>
        </div>
        <div class="flex items-center justify-end">
          <airdrop-button
            width="262px"
            :activity-id="itemInfo.id"
            :btn-text="itemInfo.projectStatus === 1 && !itemInfo.userJoinStatus ? $t('前往报名') : $t('查看详情')"
            :class-name="{
              'bg-transparent text-textPrimary border border-textPrimary': itemInfo.projectStatus !== 1,
              'text-textOnBtn hover:bg-btnPrimaryHover': itemInfo.projectStatus === 1,
            }"
          />
        </div>
      </div>
    </div>
  </div>
</template>
